import React  from "react";
import { useParams } from 'react-router-dom';
import ReportForm from "./components/ReportForm";

const EditReport = () => {
	const { reportId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<ReportForm recordId={reportId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditReport;